import { render, staticRenderFns } from "./AboutProduct.vue?vue&type=template&id=409abd7e&scoped=true&"
import script from "./AboutProduct.vue?vue&type=script&lang=js&"
export * from "./AboutProduct.vue?vue&type=script&lang=js&"
import style0 from "./AboutProduct.vue?vue&type=style&index=0&id=409abd7e&prod&lang=scss&scoped=true&"
import style1 from "./AboutProduct.vue?vue&type=style&index=1&id=409abd7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409abd7e",
  null
  
)

export default component.exports